import { CToast, CToastBody, CToastHeader, CToaster } from '@coreui/react-pro'
import React, { createContext, useContext, useRef, useState } from 'react'

const ToastContext = createContext({})

const ToastsProvider = ({ children }) => {
  const [toast, setToast] = useState(0)
  const toaster = useRef()

  const exampleToast = (error) => (
    <CToast>
      <CToastHeader closeButton>
        <svg
          className="rounded me-2"
          width="20"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
        >
          <rect width="100%" height="100%" fill="#007aff"></rect>
        </svg>
        <div className="fw-bold me-auto">CoreUI for React.js</div>
        <small>7 min ago</small>
      </CToastHeader>
      <CToastBody>{error}</CToastBody>
    </CToast>
  )

  const addToast = (payload) => {
    setToast(exampleToast(payload))
  }

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <CToaster ref={toaster} push={toast} placement="top-end" />
    </ToastContext.Provider>
  )
}

const useToasts = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToasts must be used within an ToastsProvider')
  }
  return context
}

export { ToastsProvider, useToasts }
